import React from 'react';
import { useRouteError, isRouteErrorResponse } from 'react-router-dom';
import SomethingWentWrongImage from '@/assets/images/common/SomethingWentWrong.png';
import { Button } from '@mui/material';
import ReplayIcon from '@mui/icons-material/Replay';
import { BACKGROUND_COLORS, STATUS_COLORS, TEXT_COLORS } from '@/common/presentation/constants/colors';
import tid from '@/common/infrastructure/config/tid';

function devRouteErrorMessage(error: unknown): string | null {
  if (!import.meta.env.DEV || error == null) return null;

  if (isRouteErrorResponse(error)) {
    return `${error.status} ${error.statusText}${error.data != null ? `: ${String(error.data)}` : ''}`;
  }

  if (error instanceof Error) {
    return error.stack ?? error.message;
  }

  return String(error);
}

const SomethingWentWrong: React.FC = () => {
  const routeError = useRouteError();
  const devErrorDetail = devRouteErrorMessage(routeError);

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        height: '100vh',
        backgroundColor: BACKGROUND_COLORS.CALENDAR_HEADER
      }}
    >
      <div
        style={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '1rem'
        }}
      >
        <div
          style={{
            width: '200px',
            height: '200px',
            marginBottom: '1.5rem',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <img
            src={SomethingWentWrongImage}
            alt="Error illustration"
            style={{
              maxWidth: '100%',
              maxHeight: '100%',
              objectFit: 'contain'
            }}
          />
        </div>

        <h1 style={{ margin: 0, fontSize: '24px', color: TEXT_COLORS.TEXT_PRIMARY }}>Something Went Wrong!</h1>

        <p
          style={{
            fontSize: '16px',
            marginTop: '0.3em',
            margin: '1rem 0 2rem',
            color: TEXT_COLORS.MUTED,
            textAlign: 'center',
            maxWidth: '680px',
            lineHeight: 1.5
          }}
        >
          We encountered a technical issue on the system. Please try again in a few minutes. If the problem persists, please contact
          support.
        </p>

        {devErrorDetail != null && (
          <pre
            style={{
              fontSize: '12px',
              margin: '0 0 1.5rem',
              padding: '1rem',
              maxWidth: '900px',
              width: '100%',
              overflow: 'auto',
              textAlign: 'left',
              color: STATUS_COLORS.ERROR_THEME_MAIN,
              backgroundColor: BACKGROUND_COLORS.WHITE,
              borderRadius: '8px',
              whiteSpace: 'pre-wrap',
              wordBreak: 'break-word'
            }}
          >
            {devErrorDetail}
          </pre>
        )}

        <div style={{ display: 'flex', gap: '1rem' }}>
          <Button
            onClick={() => {
              alert('Report an issue clicked');
            }}
            variant="outlined"
            {...tid('common:something-went-wrong:report-issue-button')}
          >
            REPORT AN ISSUE
          </Button>

          <Button
            onClick={() => {
              window.location.reload();
            }}
            variant="contained"
            {...tid('common:something-went-wrong:retry-button')}
          >
            <ReplayIcon style={{ marginRight: '0.2rem' }} />
            RETRY
          </Button>
        </div>
      </div>
    </div>
  );
};

export default SomethingWentWrong;
